import React, { useState } from 'react';

import { Space } from 'antd';
import { Link } from 'react-router-dom';

import { CompanyOrgsInline } from './CompanyOrgsInline';
import styles from './PartnerNameCell.module.css';
import { getPartnerHierarchyTypeFromList } from '@/features/lp-village/partners/helpers/partnerHierarchy';
import { IModifiedPartner } from '@/features/lp-village/partners/models/partner';
import {
  TREE_BRANCH,
  isCompany,
  isOrganization,
} from '@/features/lp-village/partners/types/partner';

interface IPartnerNameCellProps {
  record: IModifiedPartner;
}

export const PartnerNameCell = ({ record }: IPartnerNameCellProps) => {
  const [expanded, setExpanded] = useState(false);

  const hierarchyType = getPartnerHierarchyTypeFromList(record);

  return (
    <Space direction="vertical" size={0}>
      {isOrganization(hierarchyType) && record.parentId && (
        <Link
          to={`/lp-village/partners/${record.parentId}`}
          className={styles.parentLink}
          data-testid="partner-parent-link"
        >
          {record.parentName ?? 'Company'}
        </Link>
      )}
      <span className={styles.partnerName}>
        {isOrganization(hierarchyType) && (
          <span className={styles.treeBranch}>{TREE_BRANCH}</span>
        )}
        {record.name}
      </span>
      {isCompany(hierarchyType) && (
        <CompanyOrgsInline
          partnerId={record.id}
          expanded={expanded}
          onToggle={() => setExpanded((prev) => !prev)}
        />
      )}
    </Space>
  );
};
